import Vue from "vue";
import Router from "vue-router";
// import AppHeaderV2 from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import AppHeader from "./layout/AppHeaderv2";
import BlogPosts from "@/views/blog/Posts";
import BlogPost from "@/views/blog/Post";

import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Home from "./views/user/Home.vue";
import LeadsTasks from "./views/crm/LeadsTasks";
import Page from "./views/site/Page.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Project from "./views/user/Project.vue";
import Invoices from "@/views/user/Invoices.vue";
import Invoice from "@/views/user/Invoice.vue";
import OnLogin from "@/views/OnLogin.vue";
import Setup from "@/views/user/Setup.vue";
import Portfolio from "@/views/user/Portfolio.vue";
import EditPortfolio from "./views/user/EditPortfolio.vue";
import Developer from "@/views/developer/Developer.vue";
import axios from "axios";
import Workpage from "@/views/developer/Workpage.vue";
import Review from "@/views/developer/Review.vue";
import ShopSetting from "./views/shop/Setting";
import {eventBus, vm} from "@/main";

import Leads from "./views/crm/Leads";
import Lead from './views/crm/Lead';
import Funnel from './views/crm/Funnel';
import Confirm from '@/views/site/Confirm.vue';
import Canban from "./views/user/Canban";
import Category from "./views/blog/Category";
import Invite from "./views/site/Invite";
import PortfolioCategory from "./views/site/PortfolioCategory";
import PortfolioWorks from "./views/site/PortfolioWorks";
import ServicePage    from "./views/site/ServicePage";
import ManageItems from "./views/shop/ManageItems.vue";
import ShopCategorys from "./views/shop/ShopCategorys.vue";
import Items  from "./views/shop/Items.vue";
import Item   from "./views/shop/Item.vue";
import Cart from "./views/shop/Cart.vue";
import Api from "./models/Api.js";
import RedirectTelegram from "./views/RedirectTelegram";
import UserModel from "./models/UserModel";
import store from "@/store";
import Notify from "./views/user/Notify";
import UserShop from "./views/developer/UserShop";
import Services from "./views/site/Services";
import AddPortfolio from "./views/user/AddPortfolio";
import AddPost from "./views/blog/AddPost";
import EditPost from "./views/blog/EditPost";
import AddProject from "./views/user/AddProject";
import EditProject from "./views/user/EditProject";
import AddTask from "./views/user/AddTask";
import AddLead from "./views/crm/AddLead";
import AddItem from "./views/shop/AddItem";
import EditItem from "./views/shop/EditItem";
import ArticlesList from "./views/projects/project/ArticlesList";
import ArticlesOne from "./views/projects/project/ArticlesOne";
import AddArticle from "./views/projects/project/AddArticle";
import EditArticle from "./views/projects/project/EditArticle";
import PagesCategory from "./views/pages/PagesCategory";
import PagesPage from "./views/pages/PagesPage";
import SetupService from "./views/freelance/SetupService";
import SetupLinks from "./views/user/SetupLinks";
import Page404   from "./views/404";
import Withdrawal from "./views/user/Withdrawal";
import MainUserPage from "./views/user_page/MainUserPage";
import UserPagePortfolio from "./views/user_page/UserPagePortfolio";
import UserPageOnePortfolio from "./views/user_page/UserPageOnePortfolio";
import UserPageReviews from "./views/user_page/UserPageReviews";
import UserPageItems from "./views/user_page/UserPageItems";
import UserPageServices from "./views/user_page/UserPageServices";
import UserPageService from "./views/user_page/UserPageService";
import Users from "./views/site/Users";
import VerificationForm from "./views/user/VerificationForm";
import Verifications from "./views/user/Verifications";
import AddProjectforFreelance from "./views/user/AddProjectforFreelance";
import FreelanceListTasks from "./views/user/FreelanceListTasks";
import WaitingActivate from "./views/WaitingActivate";
import ProjectInvoices from "./views/projects/project/ProjectInvoices";
import Rewards from "./views/user/Rewards";
import RewardOne from "./views/user/RewardOne";
import UserPageRewards from "./views/user_page/UserPageRewards";
import UserPageAddReview from "./views/user_page/UserPageAddReview";
import UserPageOneReview from "./views/user_page/UserPageOneReview";







Vue.use(Router);
(function() {
	'use strict';
	const { isNavigationFailure, NavigationFailureType } = Router;


	const original_push = Router.prototype.push;
	Router.prototype.push = function push(location) {
		original_push.call(this, location).catch(error => {
			if(!isNavigationFailure(error, NavigationFailureType.duplicated)) {
				//throw Error(error)

				//eventBus.$emit('refresh_fast_page');
			}else {
				eventBus.$emit('refresh_fast_page');
			}
		})
	};
	Router.prototype.absUrl = function(url, newTab = true) {
		const link = document.createElement('a')
		link.href = url
		link.target = newTab ? '_blank' : ''
		if (newTab) link.rel = 'noopener noreferrer' // IMPORTANT to add this
		link.click()
	}
	// ...ваш код...
})();





function getParameterByName(name, url = window.location.href) {
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



export default new Router({
	mode:"history",
	linkExactActiveClass: "active",
	fallback:false,
	routes: [

		{
			path: "/",
			name: "landing",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Landing,
				footer: AppFooter
			},
			meta: {
				need_login: false,


			},

		},
		{
			path: "/index.html",
			name: "landing2",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Landing,
				footer: AppFooter
			},
			meta: {
				need_login: false,

			},

		},

		{
			// /search/screens -> /search?q=screens
			path: '/redirect/',
			components: {

				default: RedirectTelegram,


			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/services",
			name: "services",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Services,
				footer: AppFooter
			},
			meta: {
				need_login: false,
			//	typebar:"site",

			},
		},
		{
			path: "/posts/new",
			name: "add_post",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddPost,
				footer: AppFooter
			},
			meta: {
				need_login: true,
				//typebar:"blog",


			},
		},
		{
			path: "/blog/edit/:id",
			name: "edit_post",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: EditPost,
				footer: AppFooter
			},
			meta: {
				need_login: true,
			//	typebar:"blog",

			},
		},
		{
			path: "/posts/:orderby",
			name: "posts_orderby",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: BlogPosts,
				footer: AppFooter
			},
			meta: {
				need_login: false,
				//	typebar:"blog",

			},
		},
		{
			path: "/posts",
			name: "posts",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: BlogPosts,
				footer: AppFooter
			},
			meta: {
				need_login: false,
			//	typebar:"blog",

			},
		},
		{
			path:"/pages/:alias/:page_alias",
			name:"pages_page",
			hash:UserModel.getGlobalHash(),
			components:{
				header:AppHeader,
				default:PagesPage,
				footer:AppFooter,
			}
		},
		{
			path:"/pages/:alias",
			name:"pages_category",
			hash:UserModel.getGlobalHash(),
			components:{
				header:AppHeader,
				default:PagesCategory,
				footer:AppFooter,
			}
		},
		{
			path: "/post/:alias/:id/:rand?",
			name: "post",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: BlogPost,
				footer: AppFooter

			},
			meta: {
				need_login: false,
			//	typebar:"blog",

			},

		},

		{
			path: "/canban/:rand?",
			name: "canban",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Canban,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				//typebar:"project",

			},
		},
		{
			path: "/notify/:rand?",
			name: "notify",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Notify,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/leadtasks/:rand?",
			name: "leadtasks",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: LeadsTasks,
				footer: AppFooter

			},
			meta: {
				need_login: true,
			//	typebar:"crm",

			},
		},
		{
			path:"/services/new_request",
			name:"freelance_new_request",
			hash:UserModel.getGlobalHash(),
			components:{
				header:AppHeader,
				default:AddProjectforFreelance,
				footer:AppFooter,
			},
			meta: {
				need_login: true,


			}
		},
		{
			path: "/project/addproject",
			name: "add_project",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddProject,
				footer: AppFooter

			},
			meta: {
				need_login: true,
			//	typebar:"project",

			},
		},
		{
			path: "/project/:id/edit",
			name: "edit_project",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: EditProject,
				footer: AppFooter

			},
			meta: {
				need_login: true,
			//	typebar:"project",

			},
		},
		{
			path:"/freelance_tasks",
			name:"freelance_tasks",
			hash:UserModel.getGlobalHash(),
			components:{
				header:AppHeader,
				default:FreelanceListTasks,
				footer:AppFooter
			},
			meta:{
				need_login:true,

			}
		},
		{
			path: "/home/:rand?",
			name: "home",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Home,
				footer: AppFooter

			},
			meta: {
				need_login: true,
			//	typebar:"project",

			},
		},
		{
			path: "/lead/:id/:rand?",
			name: "lead",
			components: {
				header: AppHeader,
				default: Lead,
				footer: AppFooter

			},
			meta: {
				need_login:true,
				//typebar:"crm",

			},

		},
		{
			path: "/confirm/:id/:rand?",
			name: "confirm",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Confirm,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},


		},
		{
			path: "/invite/:id/:code/:rand?",
			name: "invite",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Invite,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},


		},
		{
			path: "/leads/add",
			name: "add_lead",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddLead,
				footer: AppFooter

			},
			meta: {
				need_login: true,
			//	typebar:"crm",

			},

		},
		{
			path: "/funnel/:id/:rand?",
			name: "funnel",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Funnel,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				//typebar:"crm",

			},

		},
		{
			path: "/leads/",
			name: "leads",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Leads,
				footer: AppFooter

			},
			meta: {
				need_login: true,
			//	typebar:"crm",


			},
		},
		{
			path: "/page/:alias",
			name: "page",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Page,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},
		},
		{
			path: "/project/:id/articles",
			name: "list_articles",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: ArticlesList,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				//typebar:"project",

			},
		},
		{
			path: "/project/:id/articles/add/:parent_id?",
			name: "add_article",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddArticle,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				//typebar:"project",
			},
		},
		{
			path: "/project/:id/articles/edit/:post_id",
			name: "edit_article",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: EditArticle,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				//typebar:"project",

			},
		},
		{
			path: "/project/:id/articles/:post_id",
			name: "one_article",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: ArticlesOne,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"project",

			},
		},
		{
			path: "/project/:id/addtask",
			name: "add_task",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddTask,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"project",

			},
		},
		{
			path: "/project/:id/invoices",
			name: "project_list_invoices",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: ProjectInvoices,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"project",

			},
		},
		{
			path: "/project/:id/:rand?",
			name: "project",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Project,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"project",

			},
		},

		{
			path: "/portfolio/add",
			name: "add_portfolio",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddPortfolio,
				footer: AppFooter

			},
			meta: {
				need_login: true,


			},
		},
		{
			path: "/portfolio/edit/:id",
			name: "edit_portfolio",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: EditPortfolio,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/rewards/:id",
			name: "reward_one",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: RewardOne,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/rewards",
			name: "rewards",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Rewards,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/setup/developer",
			name: "portfolio",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Portfolio,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
		       "path":"/setup/shop",
			"name":"shop_setting",
			hash:UserModel.getGlobalHash(),
			"components":{
		    	header:AppHeader,
				default:ShopSetting,
				footer: AppFooter
			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/shop/my",
			name: "shop_my",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: ManageItems,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/shop/my/add",
			name: "add_item",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: AddItem,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/shop/my/edit/:id",
			name: "edit_item",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: EditItem,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},

		{
			path: "/cart",
			name: "shop_cart",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Cart,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"cart",

			},

		},
		{
			path: "/shop/category/:id/",
			name: "shop_category_id",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Items,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/shop/item/:id/",
			name: "shop_item_id",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Item,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",
			},

		},
		{
			path: "/shop",
			name: "shop_categorys",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: ShopCategorys,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",
			},

		},
		{
			path: "/invoices",
			name: "invoices",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Invoices,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/invoice/:id/:rand?",
			name: "invoice",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Invoice,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/developer/:username",
			name: "developer",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Developer,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/developer/:username/catalog",
			name: "developer_catalog",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: UserShop,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/developer/:username/review",
			name: "reviewpage",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Review,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/developer/:username/:work_id",
			name: "workpage",
			components: {
				header: AppHeader,
				default: Workpage,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path:"/setup/service/:id",
			name:"setup_service",
			hash:UserModel.getGlobalHash(),
			components:{
				header:AppHeader,
				default:SetupService,
				footer:AppFooter,
			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/setup",
			name: "setup_link",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: SetupLinks,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/setup/profile",
			name: "setup",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default: Setup,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/wait_activate",
			name: "wait_activate",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:WaitingActivate,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},

		},
		{
			path: "/login",
			name: "login",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Login,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/works",
			name: "works_category",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:PortfolioCategory,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/works/:category_id",
			name: "works_in_category",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:PortfolioWorks,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/service/:id/new_request",
			name: "service_new_request",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:AddProjectforFreelance,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"site",


			},

		},
		{
			path: "/users",
			name: "users_list",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Users,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/service/:service_id/:tag?",
			name: "service_page",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:ServicePage,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/portfolio/:work_id",
			name: "user_page_one_portfolio",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageOnePortfolio,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/catalog",
			name: "user_page_items",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageItems,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/rewards",
			name: "user_page_rewards",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageRewards,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/review/:id",
			name: "user_page_one_review",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageOneReview,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/reviews",
			name: "user_page_reviews",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageReviews,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/addreview",
			name: "user_page_addreview",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageAddReview,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/portfolio",
			name: "user_page_portfolio",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPagePortfolio,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/services",
			name: "user_page_services",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageServices,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},
		{
			path: "/id:user_id/service/:service_id",
			name: "user_page_service",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:UserPageService,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"site",

			},

		},
		{
			path: "/setup/verifications",
			name: "setup_verifications",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Verifications,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"site",

			},
		},
		{
			path: "/setup/verification/:id",
			name: "setup_verification_form",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:VerificationForm,
				footer: AppFooter

			},
			meta: {
				need_login: true,
				typebar:"site",

			},
		},
		{
			path: "/id:user_id",
			name: "user_page_main",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:MainUserPage,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"site",

			},

		},

		{
			path: "/withdrawal",
			name: "withdrawal",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Withdrawal,
				footer: AppFooter

			},
			meta: {
				need_login: true,


			},

		},
		{
			path: "/404",
			name: "404",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Page404,
				footer: AppFooter

			},
			meta: {
				need_login: false,


			},

		},
		{
			path: "/:alias",
			name: "category_blog",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Category,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"blog",

			},

		},
		{
			path: "/:alias/:orderby",
			name: "category_blog_orderby",
			hash:UserModel.getGlobalHash(),
			components: {
				header: AppHeader,
				default:Category,
				footer: AppFooter

			},
			meta: {
				need_login: false,
				typebar:"blog",

			},

		},





	],


scrollBehavior(to, from, savedPosition) {
	// if(to.hash && to.hash.includes("tgWebAppData=")){
	// 	var urls=to.fullPath.split("#tgWebAppData=");
	// 	if(urls[0]){
	//
	// 		var new_route={};
	// 		new_route.path=urls[0];
	// 		new_route.query={t: new Date().getTime()};
	// 		if(to.query.rand_code){
	// 			new_route.query.rand_code=to.query.rand_code;
	// 		}
	// 		if(to.query.redirect_inner){
	// 			new_route.query.redirect_inner=to.query.redirect_inner;
	// 		}
	// 		vm.$router.push({path: urls[0]});;
	// 	}
	//
	// }

	if (to.hash && to.hash.includes("tgWebAppData=")==false && to.hash.includes("inner_link")==false) {
		// Required because our <RouterView> is wrapped in a <Transition>
		// So elements are mounted after a delay
		Api.tryScrollToAnchor(to.hash, 1000, 100);
	} else if (savedPosition) {
		return savedPosition;
	} else {
		return { x: 0, y: 0 };
	}
}
});
